import styled from 'styled-components';

const ICON_COLOR = '#666';
const ICON_SIZE = 14;
const PILLS_GUTTER = 10;
const BORDER_COLOR = '#eee';

export const StyledFilterList = styled.div`
  > div {
    border-bottom: solid 1px ${BORDER_COLOR};
  }
`;

export const StyledPillsList = styled.div`
  ${({ theme }) => theme.custom.helpers.LayoutContainer``};
  padding: 0 calc(var(--outerGutter) - ${PILLS_GUTTER}px);
  display: flex;
  flex-wrap: wrap;
  padding-bottom: ${PILLS_GUTTER}px;
  @media ${({ theme }) => theme.custom.layouts.above_large} {
    flex-wrap: nowrap;
  }

  > div {
    padding: 0 ${PILLS_GUTTER}px;
  }
`;

export const StyledPill = styled.div`
  cursor: pointer;
  height: 40px;
  border: solid 1px black;
  border-radius: 9999px;
  padding: 6px 20px;
  margin-top: ${PILLS_GUTTER}px;

  display: flex;
  align-items: center;
  background-color: transparent;
  transition: all 0.3s ease;

  /* Title */
  > span:first-of-type {
    white-space: nowrap;
    padding-right: ${PILLS_GUTTER}px;
    transition: transform 0.3s ease;
  }
  /* Icon */
  > div:last-of-type {
    width: ${ICON_SIZE}px;
    height: ${ICON_SIZE}px;
    transition: all 0.3s ease;
    overflow: hidden;
    position: relative;
    transform: rotate(45deg);
    &:before,
    &:after {
      content: '';
      position: absolute;
      display: block;
      width: 2px;
      height: ${ICON_SIZE}px;
      background: ${ICON_COLOR};
      left: 50%;
      top: 50%;
      transition: all 0.3s ease;
      transform-origin: center center;
    }
    &:before {
      transform: translate(-50%, -50%) rotate(90deg);
    }
    &:after {
      transform: translate(-50%, -50%);
    }
  }

  @media ${({ theme }) => theme.custom.layouts.above_large} {
    > div:last-of-type {
      transform: scale(0) rotate(0deg);
    }

    > span:first-of-type {
      transform: translateX(${ICON_SIZE}px);
    }
  }

  @media (hover: hover) {
    &:hover {
      background: ${ICON_COLOR};
      color: white;

      & > span:first-of-type {
        transform: translateX(0px);
      }
      & > div:last-of-type {
        transform: scale(1) rotate(45deg);

        &:before,
        &:after {
          background: white;
        }
      }
    }
  }
`;
